







import Vue from 'vue'
import { setSearchQuery } from '../store/actions';
import { routerReplace } from '../helpers';
import { EventBus } from '../helpers/EventBus.vue' 
interface SearchInputData {
    query: string
}

interface SearchInputMethods {
	setSearchQuery(): void
}

export default Vue.extend<SearchInputData, SearchInputMethods, {} , {}>({
	name: 'SearchInput',
	props: {
		article: {}
	},
    data() {
        return {
            query: ''
        }
    },
    methods: {
        setSearchQuery() {
            this.$store.dispatch(setSearchQuery({query: this.query}))
            routerReplace({
				query: this.$store.getters.getParams
			})
            EventBus.$emit('scrollToTop');
        }
    }
})
